import { render } from "./Users.vue?vue&type=template&id=f5b07c22&scoped=true&ts=true"
import script from "./Users.vue?vue&type=script&lang=ts"
export * from "./Users.vue?vue&type=script&lang=ts"

import "./Users.vue?vue&type=style&index=0&id=f5b07c22&scoped=true&lang=css"

import exportComponent from "/Users/abdulkarim/workspace/public_html/joypurhost/pos2/pos2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5b07c22"]])

export default __exports__